/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { CalibrationAnnualPlan } from '../model/calibration';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { HttpUtils } from '../utils/httpUtils';

@Injectable({
  providedIn: 'root'
})
export class CalibrationAnnualPlanService {

  readonly baseUrl = `${environment.equipmentUrl}/calibrationAnnualPlan`
  constructor(private http: HttpClient) { }

  save(calibration: CalibrationAnnualPlan): Observable<any> {
    let url = `${this.baseUrl}/create`;
    return this.http.post(url, calibration).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  deleteById(idCalibrationPlan: number): Observable<any> {
    let url = `${this.baseUrl}/${idCalibrationPlan}`;
    return this.http.delete(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  signPlan(calibration: CalibrationAnnualPlan): Observable<any> {
    const url = `${this.baseUrl}/sign`;
    return this.http.post(url, calibration).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  findAll(): Observable<any> {
    return this.http.get(`${this.baseUrl}/allGroup`).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  findAllCurrent(): Observable<any> {
    return this.http.get(`${this.baseUrl}/allGroupCurrent`).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  downloadCalibrationPlanByIdAttachment(idAttachment: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/attachment/${idAttachment}`, { responseType: 'blob' });
  }

  generateCalibrationPlanById(id: number): Observable<any> {
    return this.http.get(`${environment.equipmentUrl}/report/calibrationAnnualPlan/${id}`, { responseType: 'blob' });
  }

  generateExcelCalibrationPlanById(id: number): Observable<any> {
    return this.http.get(`${environment.equipmentUrl}/report/calibrationAnnualPlan/excel/${id}`, { responseType: 'blob' });
  }

  saveVersion(id: number, reason: string): Observable<any> {
     const form = new FormData();
    form.append('reason', reason);
    return this.http.post(`${this.baseUrl}/newVersion/${id}`, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  manualSign(id: number, file: File, token: string): Observable<any> {
    const url = `${this.baseUrl}/${id}/manualSign`;

    const form = new FormData();
    form.append('file', file, file.name);
    form.append('token', token);
    return this.http.post(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  existsPlanCalibrationSigned(idEquipment: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/equipment/${idEquipment}`).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  existsPlanCalibrationCode(code: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/exist/${code}`).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  invalidate(id: number, reason: string): Observable<any> {
    let url = `${this.baseUrl}/${id}/invalidate`;
    const form = new FormData();
    form.append('reason', reason);
    return this.http.post(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  generateManualCalibrationPlanById(id: number): Observable<any> {
    return this.http.get(`${environment.equipmentUrl}/report/manual/calibrationAnnualPlan/${id}`, { responseType: 'blob' });
  }
}
